import { Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import type { ChatRailTokens } from "../../tokens";
import { JsonResultRenderer } from "./JsonResultRenderer";
import { ScalarRow, pickStringField } from "./registry";

export function PartnerRenderer({
  kind,
  payload,
  T,
}: {
  kind: "invocation" | "result";
  payload: unknown;
  T: ChatRailTokens;
}) {
  if (kind === "invocation") return <JsonResultRenderer payload={payload} T={T} />;

  const id = pickStringField(payload, "id", "partner_id", "partner_company_id");
  const name = pickStringField(payload, "name", "company_name", "partner_name");
  const tier = pickStringField(payload, "tier", "partner_tier");

  if (!name && !id) return <JsonResultRenderer payload={payload} T={T} />;

  return (
    <Stack spacing={0.5}>
      {name && id ? (
        <ScalarRow
          label="partner"
          value={
            <RouterLink to={`/partners/${id}`} style={{ color: T.accent, textDecoration: "none" }}>
              {name}
            </RouterLink>
          }
          T={T}
        />
      ) : name ? (
        <ScalarRow label="partner" value={name} T={T} />
      ) : null}
      {tier && <ScalarRow label="tier" value={tier} T={T} />}
    </Stack>
  );
}
